import { BrandMark } from "../layout/BrandMark";
import { MobileContent } from "../layout/MobileContent";
import MobileHeader from "../layout/MobileHeader";
import { ExecutiveDashboard } from "./ExecutiveDashboard";

/** Phone home page: brand bar on top, the same weekly dashboard in one column. */
export const MobileDashboard = () => (
  <>
    <MobileHeader>
      <BrandMark />
    </MobileHeader>
    <MobileContent>
      <ExecutiveDashboard />
    </MobileContent>
  </>
);
